import React from 'react'
import PropTypes from 'prop-types'
import HoverPopover from '../../../../uiKit/HoverPopover'
import useCopyToClipboard from '../../../../hooks/useCopyToClipboard'
import InfoButton from '../../../../uiKit/icons/InfoButton'
import classes from './styles.module.scss'

/**
 * "Email format" trigger button + popover that shows the required email subject
 * format and lets the user copy it to clipboard.
 */
const EmailFormatPopover = ({ activeBotId }) => {
    const { isCopied, copyToClipboard } = useCopyToClipboard()

    const handleCopy = () => {
        const text = `Organisation ID: ${activeBotId} , Service user First Name: <First Name> , Service user Last Name: <Last Name>`
        copyToClipboard(text)
    }

    return (
        <HoverPopover
            title="Required email subject format"
            width={400}
            trigger={({ ref, handlers }) => (
                <div ref={ref} className={classes.formatTrigger} {...handlers}>
                    <InfoButton color="rgba(51, 51, 51, 1)" />
                    <span className={classes.formatTriggerText}>Email format</span>
                </div>
            )}
        >
            <div className={classes.popoverDescription}>
                Subject title for all emails must follow this format exactly.
            </div>
            <div className={classes.popoverFormatBox}>
                Organisation ID: <span className={classes.tagValue}>{activeBotId}</span> , Service user First Name: <span className={classes.tagValue}>&lt;First Name&gt;</span>, Service user Last Name: <span className={classes.tagValue}>&lt;Last Name&gt;</span>
            </div>
            <button
                className={classes.popoverCopyLink}
                onClick={handleCopy}
                style={isCopied ? { color: '#4CAF50' } : {}}
            >
                <img
                    src={isCopied ? '/images/platform/iconCopied.svg' : '/images/platform/iconCopy.svg'}
                    alt="copy"
                    style={{ marginRight: 3 }}
                />
                {isCopied ? 'Copied' : 'Copy format'}
            </button>
        </HoverPopover>
    )
}

EmailFormatPopover.propTypes = {
    activeBotId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
}

export default EmailFormatPopover
